export default "__VITE_ASSET__CDmIR_5L__"